module.exports = __webpack_public_path__ + "static/img/copyright2.57846669.png";